import { Modal } from "react-bootstrap";
import "../../PurchaseOrders/PurchaseOrders.css";


export default function PIModal(props) {
    return (
        <div>
            <Modal show={props.show} onHide={props.hide} size="lg" centered>
                <Modal.Header className="return-header">
                    <span className="text-warning"> PLEASE CONFIRM </span>
                </Modal.Header>
                <Modal.Body className="return-body text-center">
                    <span>Are you sure you want to {props.type} this {props.page}?</span>
                    <div className="d-flex justify-content-end pt-3">
                        <button type="button" className={props.type === "disapprove" ? "button-warning me-1" : "button-secondary me-1"} onClick={props.hide}>Cancel</button>
                        <button type="button" className={props.type === "disapprove" ? "button-warning-fill" : "button-primary"} onClick={props.handler}>Proceed</button>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}